import { Component } from 'preact';

class LazyImage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lowResImage: '',  // The base64 string or low-res image source
            highResImage: '', // The high-res image source
            isLoaded: false,  // Track if the image is fully loaded
        };
    }

    componentDidMount() {
        // Initialize with the low-res base64 image as a placeholder
        const { lowResBase64, src } = this.props;

        this.setState({
            lowResImage: lowResBase64 ? `data:image/jpeg;base64,${lowResBase64}` : '',
            highResImage: src,
        });
    }

    handleImageLoad = () => {
        // Once the high-res image has loaded, update the state to indicate it's fully loaded
        this.setState({ isLoaded: true });
    }

    render() {
        const { lowResImage, highResImage, isLoaded } = this.state;
        const { alt, className, style, onClick, onDoubleClick = () => {}, ...restProps } = this.props;

        return (
            <div class={`lazy-image-container ${className || ''}`}>

                {/* High-res image that will fade in */}
                {highResImage ? <>
                    <img
                        src={highResImage}
                        alt={alt || 'Image'}
                        onLoad={this.handleImageLoad}
                        onDoubleClick={onDoubleClick}
                        style={`
                            width: 100%;
                            height: auto;
                            opacity: ${isLoaded ? 1 : 0};
                            transition: opacity 0.1s ease-in;
                            object-fit: cover;
                            ${style ? style : ''};
                        `}
                        {...restProps} // Spread the remaining props (e.g., onClick, data-attributes, etc.)
                    />
                </> : <>
                    {/* Low-res placeholder image */}
                    <img
                        src={lowResImage}
                        alt={alt || 'Image loading...'}
                        onDoubleClick={onDoubleClick}
                        style={`
                            width: 100%;
                            height: auto;
                            opacity: ${isLoaded ? 0 : 1};
                            transition: opacity 0.1s ease-out;
                            object-fit: cover;
                            ${style ? style : ''};
                        `}
                        {...restProps} // Spread the remaining props (e.g., onClick, data-attributes, etc.)
                    />
                </>}
            </div>
        );
    }
}

export default LazyImage;